import { Badge, Box, Grid, Paper, Typography } from '@material-ui/core';
import { BuildOutlined, CloudDownloadRounded, DescriptionOutlined, GroupOutlined, PaymentOutlined, PhoneInTalkOutlined, SettingsOutlined, StorefrontOutlined, WorkOutlined, WorkOutlineOutlined } from '@material-ui/icons';
import { isEmpty } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';


class ColorBox extends Component {
    state = {  }
    render() {
        return (
            <Paper 
                onClick={() => this.props.ClickOnMenu(this.props.component || this.props.title)}
                style={{
                    cursor: "pointer",
                    margin: "auto",
                    // borderRadius: "50%",
                    // background: "yellow",
                    // width: "150px",
                    // height: "150px",
                    // background: "whitesmoke",
                    // border: "3px solid #9575cd",
                }} 
            >
                <Box p={2} style={{ textAlign: "center"}}>
                    <Box p={1}>
                        {this.props.icon}
                    </Box>
                    <Typography variant="h6" noWrap color="secondary">
                    {this.props.title}
                    </Typography>
                </Box>
            </Paper>          
        );
    }
}

const btnList = [
    {title: "Clients", color: "#e1bee7", icon: <GroupOutlined color="secondary" fontSize="large"/>, component:"Home" },
    {title: "Paiement", color: "#d1c4e9", icon: <PaymentOutlined color="secondary" fontSize="large"/> },
    {title: "Commercial", color: "#c5cae9", icon: <WorkOutlineOutlined color="secondary" fontSize="large"/> },
    {title: "Devis", color: "#b3e5fc", icon: <DescriptionOutlined color="secondary" fontSize="large"/> },
    {title: "Magasin", color: "#b2ebf2", icon: <StorefrontOutlined color="secondary" fontSize="large"/> },
    {title: "Maintenance", color: "#b2dfdb", icon: <BuildOutlined color="secondary" fontSize="large"/> },
    {title: "Recouvrement", color: "#b2dfdb", icon: <PhoneInTalkOutlined color="secondary" fontSize="large"/> },
    {title: "Configuration", color: "#bbdefb", icon: <SettingsOutlined color="secondary" fontSize="large"/> },
    {title: "Paramètres", color: "#bbdefb", icon: <SettingsOutlined color="secondary" fontSize="large"/> },
    // {title: "Extract", color: "#bbdefb", icon: <CloudDownloadRounded color="secondary" fontSize="large"/>, component: "Extract"},
]

class Home extends Component {
    state = { 
        list: []
    }

    render() {
        const { pageList } = this.props;
        let list = []
        if (!isEmpty(pageList)) {
            list = btnList.filter(page => pageList.includes(page.component) || pageList.includes(page.title))
            console.log("not empty",{pageList});
        }
        return (
                <Box style={{
                    background: "whitesmoke",
                }}>
                    <Box p={2} 
                        style={{
                            marginTop: "56px", 
                            minHeight: "450px", 
                            color: "white",
                            background: "url(/img/pink.jpg)",
                            backgroundSize: "cover",
                            backgroundPosition: "left",
                            position: "relative"
                            // backgroundImage:"linear-gradient(to bottom, #9762c2, #ab80cf, #c09ddc, #d4bce8, #e8daf4)",
                            // background: "url(/img/bckg2.png)",
                            // background: "url(/img/coiffeur.jpg)",
                        }}
                    >
                        <Typography variant="h5"
                            color="secondary"
                            style={{
                                textAlign: 'right',
                                position: "absolute",
                                bottom: "100px",
                                right: 0,
                                background: "#ffffffb8",
                                padding: "7px",
                                width: "50%",
                                // color: purple

                            }}
                        >
                            MyJouleBox, Manager App
                        </Typography>
                    </Box>       
                    <Box style={{
                        minHeight: "calc(100vh - 85px - 500px)",
                        borderLeft: "50vw solid whitesmoke",
                        borderRight: "50vw solid whitesmoke",
                        borderTop: "50px solid transparent",
                        position: "relative",
                        top: "-50px"
                    }}>
                        <Grid container spacing={2} style={{
                            left: "-50vw",
                            position: "relative",
                            width: "100vw",
                            margin: "auto",
                            padding: "20px",

                        }}>
                            {list.map(box =>
                                <Grid item xs={12} sm={4} md={3}>
                                    <ColorBox {...box} ClickOnMenu={this.props.ClickOnMenu} />
                                </Grid>
                            )}
                        
                        </Grid>
                    </Box>         
                </Box>
        );
    }
}

function mapStateToProps(state){
    return {
        pageList : state.userAccess.PAGES
    }
}

export default connect(mapStateToProps)(Home);